"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _rcSlider = _interopRequireDefault(require("rc-slider"));
var _constants = require("../../constants");
require("rc-slider/assets/index.css");
var _context;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var style = {
  "slider": "au_slider-module__slider___GS9YD",
  "slider-disabled": "au_slider-module__slider-disabled___SPIA1",
  "rc-slider-handle": "au_slider-module__rc-slider-handle___MfC82"
};
class AuSlider extends _react.default.Component {
  static propTypes = {
    min: T.number,
    max: T.number,
    name: T.string,
    marks: T.object,
    value: T.number,
    defaultValue: T.number,
    readonly: T.bool,
    onChange: T.func,
    className: T.string
  };
  static defaultProps = {
    className: '',
    marks: {},
    readonly: false,
    showMarks: true,
    onChange: _constants.NOOP
  };
  handleOnChange = (0, _bind.default)(_context = this.handleOnChange).call(_context, this);
  handleOnChange(value) {
    const {
      name
    } = this.props;
    this.props.onChange({
      target: {
        type: 'range',
        name,
        value
      }
    });
  }
  render() {
    let {
      min,
      max,
      name,
      value,
      defaultValue,
      marks,
      showMarks,
      readonly,
      className
    } = this.props;
    marks = showMarks && ((0, _keys.default)(marks).length ? marks : {
      [min]: min,
      [max]: max
    });
    return /*#__PURE__*/_react.default.createElement(_rcSlider.default, {
      className: (0, _classnames.default)(className, style.slider),
      key: name,
      min: min,
      max: max,
      marks: marks,
      value: value,
      defaultValue: defaultValue,
      disabled: readonly,
      onChange: this.handleOnChange
    });
  }
}
exports.default = AuSlider;